import { API_URL, ASSETS, URL, PLATFORM_FEE } from '../config.js';
import { printdDate } from '../helper.js';
import View from './View';

class SingleOrderView extends View {
  _parentElement = document.querySelector('.main');
  _errorMessage = 'Single Order View Error Message';
  _message = 'Single Order View Success Message';

  addHandlerGetOrder(handler) {
    this._parentElement.addEventListener('click', e => {
      const order = e.target.closest('.orderlist__item--detail');
    });
  }

  _generateMarkup() {
    const orders = this._data;

    const orderMarkup = orders
      .map(
        order => `
                    <li class="orderlist__item" >
                <div class="orderList__item--container">
                  <a href="/product?${order.slug}" class="link">
                    <div class="orderlist__item--img">
                      <img
                        src="${ASSETS}images/product/${order.imageCover}"
                        alt="${order.tag}"
                      />
                    </div>
                  </a>
                  <a href="?#${order._id}" class="orderlist__item--detail orderlist__link" data-id=${order._id}>
                    <div class="">
                      <h3 class="orderlist__item--title">
                        ${order.brand}
                      </h3>
                      <h4 class="orderlist__item--tag">${order.tag}</h4>
                      <div class="product__size--button">
                        <button
                          class="product__size--btn product__size--btn-selected orderlist__size"
                          data-size="${order.size}"
                        >
                          ${order.size}
                        </button>
                      </div>
                    </div>

                    <div class="orderlist__item--price">
                      <span class="orderlist__item--discounted-price"
                        >₹ ${order.price}</span
                      >
                      ${
                        order.mrp && order.mrp - order.price > 0
                          ? `<span class="orderlist__item--mrp">₹ ${order.mrp}</span> 
                      <span class="orderlist__item--discount-percent"
                        >(${Math.ceil(((order.mrp - order.price) * 100) / order.mrp)}% OFF)</span
                      >`
                          : ''
                      }
                      
                    </div>
                  </a>
                </div>
                ${
                  order.deliveryDate
                    ? `<p class="orderlist__status orderlist__status--delivered">
                        Delivered on:                     
                        ${printdDate(order.deliveryDate)} 
                        ${order.paymentMethod === 'cod' ? `| <strong>COD</strong>` : ``}
                      </p>`
                    : `${
                        order.paymentMethod
                          ? `<p class="orderlist__status">
                          Expected delivery on: 
                          ${printdDate(order.expectedDelivery)} 
                          ${order.paymentMethod === 'cod' ? `| <strong>COD</strong>` : ``}
                      </p>`
                          : `<p class="orderlist__status orderlist__status--due">
                          Payment status: ${order.deliveryStatus}
                        </p>`
                      }`
                }

      `,
      )
      .reverse()
      .join('');
    return `
                <div class="row orderlist">
        <div class="orderlist__head">
          <h2 class="orderlist__heading">Orders</h2>
        </div>

        <div class="orderlist__container">
          <div class="orderlist__items--container">
            <ul class="orderlist__items">
            ${orderMarkup}
            </ul>
          </div>
        </div>

        <!-- MANAGING orderlist ADDRESS AND PAYMENT -->
      </div>
    `;
  }
}

export default new SingleOrderView();
